'use strict';
import * as $j_app$002edata$002e$002dForm$002dQuantity$0024$0024anon$00242 from "./app.data.-Form-Quantity$$anon$2.js";
import * as $j_app$002edata$002e$002dInvoice$002dLine$002dItem$002dForm from "./app.data.-Invoice-Line-Item-Form.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dGross$002dWeight$0024 from "./app.data.data_point_types$package$-Gross-Weight$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dItem$002dReference$002dNumber$0024 from "./app.data.data_point_types$package$-Item-Reference-Number$.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dNet$002dWeight$0024 from "./app.data.data_point_types$package$-Net-Weight$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_InvoiceLineItem$$anon$1() {
}
export { $c_Lapp_data_InvoiceLineItem$$anon$1 as $c_Lapp_data_InvoiceLineItem$$anon$1 };
$p = $c_Lapp_data_InvoiceLineItem$$anon$1.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_InvoiceLineItem$$anon$1;
/** @constructor */
function $h_Lapp_data_InvoiceLineItem$$anon$1() {
}
export { $h_Lapp_data_InvoiceLineItem$$anon$1 as $h_Lapp_data_InvoiceLineItem$$anon$1 };
$h_Lapp_data_InvoiceLineItem$$anon$1.prototype = $p;
$p.bYG = (function(src) {
  var $x_9 = src.BE;
  var $x_8 = src.z1;
  var $x_7 = src.LH;
  var $x_6 = src.LI;
  var $x_5 = src.uN;
  var $x_4 = new $j_app$002edata$002e$002dForm$002dQuantity$0024$0024anon$00242.$c_Lapp_data_FormQuantity$$anon$2($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dGross$002dWeight$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$GrossWeight$().eY()).K9(src.qH);
  var $x_3 = new $j_app$002edata$002e$002dForm$002dQuantity$0024$0024anon$00242.$c_Lapp_data_FormQuantity$$anon$2($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dNet$002dWeight$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$().eY()).K9(src.qI);
  var $x_2 = src.yZ;
  var this$17 = src.z0;
  if (this$17.c()) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var arg1 = this$17.g();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dItem$002dReference$002dNumber$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ItemReferenceNumberForm$().aG().ak(arg1));
  }
  return new $j_app$002edata$002e$002dInvoice$002dLine$002dItem$002dForm.$c_Lapp_data_InvoiceLineItemForm($x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1);
});
$p.ak = (function(src) {
  return this.bYG(src);
});
var $d_Lapp_data_InvoiceLineItem$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_InvoiceLineItem$$anon$1, "app.data.InvoiceLineItem$$anon$1", ({
  DW: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_InvoiceLineItem$$anon$1 as $d_Lapp_data_InvoiceLineItem$$anon$1 };
//# sourceMappingURL=app.data.-Invoice-Line-Item$$anon$1.js.map
